//TODO: Cambiar nombre
OrdenesGridCtrl2.$inject = ['$log'];
export default function OrdenesGridCtrl2($log) {
    var vm = this;

    // vm.anyadirOrden = function () {
    //     var promise = OrdenActionsService.anyadirOrden();
    //     promise.then(function () {
    //         $window.location.reload();
    //     });
    // };
}